module.exports = __webpack_public_path__ + "static/media/quickbase-icon.b181b1ab.svg";